export default "__VITE_ASSET__CxyoOCiv__"